/**
 * useUserData
 */

import {
    Queries,
    ApolloLib,
} from 'bdvp-graphql';

const {
    useQuery,
} = ApolloLib;

const {
    GET_USER_DATA,
} = Queries;

const useUserData = () => {

    const {
        loading,
        data,
        error,
    } = useQuery(
        GET_USER_DATA,
        {
            ssr: false,
        }
    );

    return {
        loading,
        error,
        data: data?.userData || {},
    };

};

export default useUserData;
